module.exports = __webpack_public_path__ + "static/media/rewardstars.7cfae07a.png";